const TIKTOK_PIXEL_ID = 'D9EEA5RC77U2EG6DN200';

export function trackTikTokEvent(event, properties) {
  if (typeof window.ttq !== 'undefined' && window.ttq) {
    try {
      window.ttq.track(event, properties || {});
    } catch (e) {
      console.warn(`[TikTok Pixel] track(${event}) failed:`, e);
    }
  }
}

export function trackTikTokIdentify(phone, email) {
  if (typeof window.ttq !== 'undefined' && window.ttq) {
    try {
      window.ttq.identify({ phone_number: phone, email: email });
    } catch (e) {
      console.warn('[TikTok Pixel] identify() failed:', e);
    }
  }
}

const FACEBOOK_PIXEL_ID = '993466670351780';

export function trackFacebookEvent(event, properties) {
  if (typeof window.fbq !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', event, properties || {});
    } catch (e) {
      console.warn(`[Facebook Pixel] track(${event}) failed:`, e);
    }
  }
}

export default TIKTOK_PIXEL_ID;
